import { useMutation } from '@tanstack/vue-query'
import { logout } from '../authEndpoints'

// Server-side logout. The caller (AppLayout) orchestrates store cleanup, cache
// clearing and navigation in a try/finally, so the local session is cleared
// even on network failure. Nothing to invalidate — the whole cache is cleared.
export function useLogoutMutation() {
  return useMutation({
    mutationFn: (refreshToken: string) => logout(refreshToken),
  })
}
